import React from 'react';
import { footerDisclaimers, footerLinks } from '../data/content';
import { ReferralButton } from './ReferralButton';
import { Logo } from './Logo';
export function Footer() {
  return <footer className="border-t border-hairline bg-surface px-5 pb-28 pt-16 lg:px-8 lg:pb-16" data-id="element-58" data-mp="32o48q3wk3w3d">
      <div className="mx-auto max-w-shell" data-id="element-59" data-mp="36p6c8wxiaub5">
        <div className="flex flex-col gap-10 border-b border-hairline pb-10 md:flex-row md:items-start md:justify-between" data-id="element-60" data-mp="36pzb7bq84fiq">
          <div data-id="element-61" data-mp="3ucxmzw3eezab">
            <Logo data-id="element-62" data-mp="38qu4u3bljp2" />
            <p className="mt-4 max-w-[280px] text-[13px] leading-relaxed text-ink-muted" data-id="element-63" data-mp="3990ijjp5eap">
              Página independiente de promoción y referido. No afiliada oficialmente a Bybit.
            </p>
          </div>

          <nav aria-label="Pie de página" data-id="element-64" data-mp="3qcdsz1e4gbse">
            <ul className="flex flex-wrap gap-x-6 gap-y-3" data-id="element-65" data-mp="3qfjfc8vd8zkf">
              {footerLinks.map(link => <li key={link.label} data-id="element-66" data-mp="2a1jjb8zn5u2g">
                  <a href={link.href} className="text-[13.5px] text-ink-muted transition-colors duration-200 ease-smooth hover:text-white" data-id="element-67" data-mp="2eyjqjn8892v5">
                    {link.label}
                  </a>
                </li>)}
              <li data-id="element-68" data-mp="3v89f2h7oxzhx">
                <ReferralButton location="footer" variant="ghost" size="sm" className="normal-case tracking-normal font-medium" data-id="element-69" data-mp="3v8rf7oxh4xv4">
                  Crear cuenta
                </ReferralButton>
              </li>
            </ul>
          </nav>
        </div>

        <div className="mt-8 space-y-3" data-id="element-70" data-mp="323239a09h0k">
          {footerDisclaimers.map(text => <p key={text} className="max-w-[820px] text-[11.5px] leading-relaxed text-white/35" data-id="element-71" data-mp="huwhkupa1x58">
              {text}
            </p>)}
          <p className="pt-4 text-[11.5px] text-white/25" data-id="element-72" data-mp="qsqd43f7wmrc">
            © {new Date().getFullYear()} · Sitio independiente. Todas las marcas pertenecen a sus
            respectivos propietarios.
          </p>
        </div>
      </div>
    </footer>;
}